module.exports = __webpack_public_path__ + "static/img/icon-finger.001859ef.png";